/**
 * @since 1.0.0
 */
import * as internal from "./internal/path.js";
/**
 * @since 1.0.0
 * @category type ids
 */
export const TypeId = internal.TypeId;
/**
 * @since 1.0.0
 * @category tag
 */
export const Path = internal.Path;
/**
 * An implementation of the Path interface that can be used in all environments
 * (including browsers).
 *
 * It uses the POSIX standard for paths.
 *
 * @since 1.0.0
 * @category layer
 */
export const layer = internal.layer;
//# sourceMappingURL=Path.js.map